import ActionTypes from "../Actions/ActionTypes"

const initialState = { 
    pages: []
}

const PagesReducer = (state =  initialState, action) => {
     switch(action.type){
        case ActionTypes.GET_PAGES:
            state = {...state, pages: action.payload}
        break;
         default:
      break;
     }
     return state   
}
export default PagesReducer;